import { makeStyles, createStyles, } from "@material-ui/core";
import { baseColors } from "../../";

export const panelStyles = makeStyles(() =>
    createStyles({
        background: {
            backgroundColor: baseColors.cool_gray,
        },
        collapsedHeader: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
        },
        collapsedHeaderInner: {
            display: "flex",
            flexDirection: "row",
            gap: 4,
        },
        collapsedHeaderOuter: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            
        },
        collapsedHeaderAsterisk: {
            fontSize: 16,
            color: baseColors.base_red,
        },
        collapsedHeaderText: {
            fontWeight: "bold",
        },
        collapsedSubheaderText: {
            fontSize: 16,
        },
        error: {
            color: baseColors.danger_red,
        },  
        header: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "flex-end",
        },
        headerButtons: {
            display: "flex",
            flexDirection: "row",
            gap: "16px",
            justifyContent: "space-between",
        },
        columns: {
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            width: "100%",
        },
        licenseColumn: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
        },        
        rows: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "center",
            flexFlow: "wrap",
        },
        licenseRow: {
            padding: "8px",
            "&:hover": {
                backgroundColor: "rgb(33,0,110,.08)",
            },
        },     
        licenseContent: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "self-start",
            width: "100%",
        },              
        educationInputWidth: {
            width: "auto",
        },
        customTextInputWidth: {
            width: "100px",
        },        
        yearsWithInputWidth: {
            width: "70px",
        },
        stateInputWidth: {
            width: "115px",
        },
        licenseSkillInputWidth: {
            maxWidth: "50%",
        },                
        requiredRow: {
            alignSelf: "self-end",
        },  
        customRequiredRow: {
            alignSelf: "self-end",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
        },          
        removeLicenseIcon: {
            width: "75px",
            alignSelf: "center",
        },  
        qualEditorText: {
            fontWeight: "bold",
        },
        licenseStateEditorTextRow: {
            paddingTop: "30px",
            gap: "8px",
            display: "flex",
            flexFlow: "wrap",
            alignItems: "center",
            flexDirection: "row",
        },
    })
);
